import axios from "axios";

// Resolve API base URL.
// - Dev / Preview environments (CRA dev server, *.preview.emergentagent.com): the React
//   app is served on a different origin than the backend, so we MUST use the explicit
//   REACT_APP_BACKEND_URL baked at build time.
// - Production (knvtravelz.com, group-getaway-17.emergent.host, etc.): backend + frontend
//   are served on the SAME origin via the Emergent ingress, so a relative `/api` path is
//   correct and self-healing — it works regardless of which domain (custom or default)
//   the user hits, and regardless of whether the custom-domain DNS has propagated.
const PREVIEW_HOSTS = ["localhost", "127.0.0.1"];
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isDevOrPreview =
  PREVIEW_HOSTS.includes(hostname) ||
  hostname.endsWith(".preview.emergentagent.com") ||
  hostname.endsWith(".emergentagent.com");
const BACKEND_URL = isDevOrPreview ? process.env.REACT_APP_BACKEND_URL || "" : "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchTours = async (category = "all") => {
  const { data } = await api.get(`/tours`, { params: { category } });
  return data;
};

export const fetchTour = async (slug) => {
  const { data } = await api.get(`/tours/${slug}`);
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await api.post(`/inquiries`, payload);
  return data;
};

export const fetchInquiries = async () => {
  const { data } = await api.get(`/inquiries`);
  return data;
};

export const fetchInquiryStats = async () => {
  const { data } = await api.get(`/inquiries/stats`);
  return data;
};
